export type LookupResult = 'valid' | 'cancelled' | 'superseded' | 'review' | 'invalid';

export const demoScenarios: { result: LookupResult; label: string; caseNo: string; vehicle: string; token: string }[] = [
  { result: 'valid', label: 'বৈধ নোটিশ', caseNo: 'DMP/AI/2025/0614/0748', vehicle: 'ঢাকা মেট্রো-গ-২৩-৭১০৭', token: '7K9Q-X2MP-4RTA' },
  { result: 'invalid', label: 'অবৈধ / অজানা QR', caseNo: 'DMP/AI/2025/0699/9999', vehicle: 'ঢাকা মেট্রো-গ-০০-০০০০', token: 'ZZ00-UNKN-0000' },
  { result: 'cancelled', label: 'বাতিল নোটিশ', caseNo: 'DMP/AI/2025/0612/0651', vehicle: 'ঢাকা মেট্রো-ব-১৪-২০৯৮', token: '3HT2-PL8Q-9XCA' },
  { result: 'superseded', label: 'প্রতিস্থাপিত নোটিশ', caseNo: 'DMP/AI/2025/0612/0644', vehicle: 'ঢাকা মেট্রো-গ-২১-৮৮০৩', token: '5RQ1-MV7D-2KLE' },
  { result: 'review', label: 'পর্যালোচনাধীন নোটিশ', caseNo: 'DMP/AI/2025/0614/0752', vehicle: 'ঢাকা মেট্রো-খ-১১-৪৫২৩', token: '8WD4-NB3S-6YTF' }
];

export const resultRoute: Record<LookupResult, string> = {
  valid: '/citizen/result',
  invalid: '/citizen/invalid',
  cancelled: '/citizen/cancelled',
  superseded: '/citizen/superseded',
  review: '/citizen/review'
};

function normalize(s: string): string {
  return s.replace(/\s+/g, '').replace(/[–—]/g, '-').toUpperCase();
}

export function lookupCase(caseNo: string, vehicle: string): LookupResult {
  const match = demoScenarios.find(
    (s) => s.result !== 'invalid' && normalize(s.caseNo) === normalize(caseNo) && normalize(s.vehicle) === normalize(vehicle)
  );
  return match ? match.result : 'invalid';
}
